import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { openDialog, closeDialog } from '../../actions/dialog';
import { storeWithExpiration } from '../../utils/common';
import { getPriceBook, getRevShare, updatePrice } from '../../actions/pricing';
import { SUPER_ADMIN } from '../../config/app_config';

import PricingIndex from './PricingIndex';

export class PricingIndexContainer extends React.Component {
  static propTypes = {
    account: PropTypes.object.isRequired,
    accountSettings: PropTypes.object.isRequired,
    dialog: PropTypes.object.isRequired,
    priceBook: PropTypes.object.isRequired,
    isSuperAdmin: PropTypes.bool.isRequired,
    openDialogAction: PropTypes.func.isRequired,
    closeDialogAction: PropTypes.func.isRequired,
    getPriceBookAction: PropTypes.func.isRequired,
    getRevShareAction: PropTypes.func.isRequired,
    updatePriceAction: PropTypes.func.isRequired,
  };

  componentWillMount = () => {
    const { account, getPriceBookAction, getRevShareAction } = this.props;

    const token = storeWithExpiration.get('token');
    // hard code it for now so we get provider side
    getRevShareAction(account.id, token);
    getPriceBookAction(account.id, token);
  };

  render() {
    const {
      account,
      accountSettings,
      dialog,
      priceBook,
      isSuperAdmin,
      openDialogAction,
      closeDialogAction,
      getPriceBookAction,
      updatePriceAction,
    } = this.props;

    return (
      <PricingIndex
        accountId={account.id}
        accountSettings={accountSettings}
        dialog={dialog}
        isSuperAdmin={isSuperAdmin}
        priceBook={priceBook}
        openDialogFunction={openDialogAction}
        closeDialogFunction={closeDialogAction}
        getPriceBookAction={getPriceBookAction}
        updatePriceAction={updatePriceAction}
      />
    );
  }
}

function mapStateToProps(state) {
  const { account, accountSettings, dialog, priceBook, user } = state;
  const isSuperAdmin = user.get('userTypeId') === SUPER_ADMIN;
  return {
    accountSettings,
    account,
    dialog,
    isSuperAdmin,
    priceBook,
  };
}

export default connect(mapStateToProps, {
  openDialogAction: openDialog,
  closeDialogAction: closeDialog,
  getPriceBookAction: getPriceBook,
  getRevShareAction: getRevShare,
  updatePriceAction: updatePrice,
})(PricingIndexContainer);
